import { useCallback, useEffect, useState } from 'react';
import { useAction } from './useAction';
import { getSites } from '../actions';
import { useCityParam } from './useCityParam';
import _ from 'lodash';
import { CitySites } from '../apis/sitesApis';

export const useCitySites = () => {
  const [sites, setSites] = useState<CitySites>([]);
  const sitesGet = useAction(getSites);
  const { currentCityId } = useCityParam();

  const getCitySites = useCallback(() => {
    sitesGet(currentCityId!).then((res: any) => {
      const { data } = res.value;

      setSites(data as CitySites);
    });
  }, [currentCityId, sitesGet]);

  useEffect(() => {
    if (!_.isNil(currentCityId)) {
      getCitySites();
    }
  }, [getCitySites, currentCityId]);

  return { sites, getCitySites };
};
